import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RoleGuard } from './shared/guards/role.guard';
import { Roles } from './shared/enums/enums';
import { MsalGuard } from '@azure/msal-angular';
import { IndexComponent } from './pages/index/index.component';
import { RoleAdminGuard } from './shared/guards/roleAdmin.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/index/index.module').then((module) => module.IndexModule),
    canActivate: [MsalGuard, RoleGuard],
    data: { roles: Roles },
  },
  {
    path: 'unauthorized',
    loadChildren: () =>
      import('./pages/unauthorized/unauthorized.module').then((module) => module.UnauthorizedModule),
    canActivate: [MsalGuard, RoleGuard],
  },
  {
    path: 'index',
    component: IndexComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { roles: Roles, breadcrumb: 'Accueil' },
    children: [
      {
        path: 'customer',
        loadChildren: () => import('./pages/customer/customer.module').then(m => m.CustomerModule),
        data: { breadcrumb: 'Établissements' }
      },
      {
        path: 'balancesheet',
        loadChildren: () => import('./pages/balancesheet/balancesheet.module').then(m => m.BalanceSheetModule),
        data: { breadcrumb: 'Bilans' }
      },
      {
        path: 'notifications',
        loadChildren: () => import('./pages/notification/notification.module').then(m => m.NotificationModule),
        data: { breadcrumb: 'Notifications' }
      },
      {
        path: 'my-item',
        loadChildren: () => import('./pages/item/item.module').then(m => m.ItemModule),
        data: { breadcrumb: 'Mes Items', isContributor: true }
      },
      {
        path: 'my-lever',
        loadChildren: () => import('./pages/lever/lever.module').then(m => m.LeverModule),
        data: { breadcrumb: 'Mes Leviers', isContributor: true }
      },
      {
        path: 'category',
        loadChildren: () => import('./pages/category/category.module').then(m => m.CategoryModule),
        data: { breadcrumb: 'Catégories' },
        canActivate: [MsalGuard, RoleGuard, RoleAdminGuard],
      },
      {
        path: 'item',
        loadChildren: () => import('./pages/item/item.module').then(m => m.ItemModule),
        data: { breadcrumb: 'Items' },
        canActivate: [MsalGuard, RoleGuard, RoleAdminGuard],
      },
      {
        path: 'lever',
        loadChildren: () => import('./pages/lever/lever.module').then(m => m.LeverModule),
        data: { breadcrumb: 'Leviers' },
        canActivate: [MsalGuard, RoleGuard, RoleAdminGuard],
      },
      {
        path: 'performance',
        loadChildren: () => import('./pages/performance/performance.module').then(m => m.PerformanceModule),
        data: { breadcrumb: 'Prestations' },
        canActivate: [MsalGuard, RoleGuard, RoleAdminGuard],
      },
      {
        path: 'poste',
        loadChildren: () => import('./pages/poste/poste.module').then(m => m.PosteModule),
        data: { breadcrumb: 'Postes' },
        canActivate: [MsalGuard, RoleGuard, RoleAdminGuard],
      },
      {
        path: 'unit',
        loadChildren: () => import('./pages/unit/unit.module').then(m => m.UnitModule),
        data: { breadcrumb: 'Unités' },
        canActivate: [MsalGuard, RoleGuard, RoleAdminGuard],
      },
      {
        path: 'equivalence-criteria',
        loadChildren: () => import('./pages/equivalence-criteria/equivalence-criteria.module').then(m => m.EquivalenceCriteriaModule),
        data: { breadcrumb: 'Critères d\'équivalences' },
        canActivate: [MsalGuard, RoleGuard, RoleAdminGuard],
      },
      {
        path: 'utilisateur',
        loadChildren: () => import('./pages/utilisateurs/utilisateur.module').then(m => m.UtilisateurModule),
        data: { breadcrumb: 'Utilisateurs' },
        canActivate: [MsalGuard, RoleGuard, RoleAdminGuard],
      },
      {
        path: 'affiliate',
        loadChildren: () => import('./pages/affiliate/affiliate.module').then(m => m.AffiliateModule),
        data: { breadcrumb: 'Affiliés' },
        canActivate: [MsalGuard, RoleGuard, RoleAdminGuard],
      }
    ]
  },
  {
    path: 'actionplan',
    loadChildren: () =>
      import('./pages/actionplan/actionplan.module').then(
        (module) => module.ActionPlanModule
      ),
    data: { roles: Roles },
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
